"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElBox = exports.comp = exports.ReactComputed = exports.val = exports.ReactValue = void 0;
const react_1 = require("react");
const sync_1 = require("thingies/lib/sync");
const json_equal_1 = require("@jsonjoy.com/json-equal");
class ReactValue extends sync_1.Value {
    use() {
        return (0, react_1.useSyncExternalStore)(this.subscribe, this.getSnapshot);
    }
    set(value) {
        const oldValue = this.value;
        if (!(0, json_equal_1.deepEqual)(oldValue, value))
            this.next(value);
    }
    toString() {
        return this.value + '';
    }
}
exports.ReactValue = ReactValue;
const val = (value) => new ReactValue(value);
exports.val = val;
class ReactComputed extends sync_1.Computed {
    use() {
        return (0, react_1.useSyncExternalStore)(this.subscribe, this.getSnapshot);
    }
    toString() {
        return this.value + '';
    }
}
exports.ReactComputed = ReactComputed;
const comp = (deps, compute) => new ReactComputed(deps, compute);
exports.comp = comp;
const getSize = (el) => {
    const box = el.getBoundingClientRect();
    return [box.left, box.top, box.width, box.height];
};
class ElBox extends ReactValue {
    constructor(el, size) {
        super(el ? getSize(el) : (size ?? [0, 0, 0, 0]));
        this._rafId = 0;
        this._flushSize = () => {
            this._rafId = 0;
            const el = this.el;
            if (el)
                this.set(getSize(el));
        };
        this._measure = () => {
            if (this._rafId || typeof window === 'undefined') {
                if (!this._rafId)
                    this._flushSize();
                return;
            }
            this._rafId = window.requestAnimationFrame(this._flushSize);
        };
        this.setEl = (el = void 0) => {
            const oldEl = this.el;
            if (oldEl)
                this._observer?.unobserve(oldEl);
            if (!this._observer) {
                this._observer = new ResizeObserver(() => {
                    this._measure();
                });
            }
            if (this._rafId && typeof window !== 'undefined') {
                window.cancelAnimationFrame(this._rafId);
                this._rafId = 0;
            }
            this.el = el ?? void 0;
            if (el) {
                this._observer?.observe(el);
                this.set(getSize(el));
            }
        };
        if (el)
            this.setEl(el);
        window.addEventListener('resize', this._measure);
    }
    dispose() {
        window.removeEventListener('resize', this._measure);
        this.setEl(void 0);
        if (this._rafId && typeof window !== 'undefined') {
            window.cancelAnimationFrame(this._rafId);
            this._rafId = 0;
        }
        this._observer?.disconnect();
    }
}
exports.ElBox = ElBox;
